import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { take } from 'rxjs/operators';

import { TemplateService } from '../../../../../core/lists/_services/template.service';
import { TaskTemplate } from '../../../calendar/models';
import { MedReviewConfig, MedReviewConfigKey } from '../../models';
import { MedReviewService } from '../../services/med-review.service';
import { GeneralAutocompleteComponent } from '../../../../partials/layout/general-autocomplete/general-autocomplete.component';

@Component({
  selector: 'kt-med-review-config',
  templateUrl: './med-review-config.component.html',
})
export class MedReviewConfigComponent implements OnInit {
  MedReviewConfigKey = MedReviewConfigKey;
  configKeys = Object.values(MedReviewConfigKey);
  configs: MedReviewConfig[] = [];
  index = '';
  configId = 0;
  getTemplateAutocomplete$ = this.templateService.findTaskTemplates.bind(this.templateService, {
    notAdditionalStep: true,
  });
  @ViewChild('key') key: MatSelect;
  @ViewChild('value') value: ElementRef;
  @ViewChild('templatesAutocomplete') templatesAutocomplete: GeneralAutocompleteComponent;

  constructor(
    private dialogRef: MatDialogRef<MedReviewConfigComponent>,
    private templateService: TemplateService,
    private medReviewService: MedReviewService,
  ) {}

  ngOnInit(): void {
    this.medReviewService
      .getMedReviewConfigs()
      .pipe(take(1))
      .subscribe((res) => {
        this.configs = res?.length ? res : [];

        const keys = this.configs.map((c) => c.key);
        this.configKeys = this.configKeys.filter((k) => !keys.includes(k));
      });
  }

  formatTemplateOption(template: TaskTemplate): string {
    return template?.name || '';
  }

  formatNewTemplate(template: TaskTemplate): TaskTemplate {
    return template;
  }

  reset(event?: Event): void {
    event?.stopPropagation();

    if (event) this.configKeys = this.configKeys.filter((k) => k !== this.key.value);

    this.index = '';
    this.configId = 0;
    this.key.value = '';

    setTimeout(() => (this.value.nativeElement.value = ''), 100);
  }

  addConfig(event: Event): void {
    event.stopPropagation();

    const config = {
      id: this.configId,
      key: this.key.value,
      value:
        this.key.value === MedReviewConfigKey.RELATED_TASK_TEMPLATES
          ? JSON.stringify(
              this.templatesAutocomplete?.value.map((t) => ({ id: t.id, name: t.name })),
            )
          : this.value.nativeElement.value,
    };

    this.index ? (this.configs[this.index] = config) : this.configs.push(config);

    this.configKeys = this.configKeys.filter((k) => k !== config.key);
    this.reset();
  }

  updateConfig(event: Event, idx: number, config: MedReviewConfig): void {
    event.stopPropagation();

    this.index = `${idx}`;
    this.configId = config.id;
    this.key.value = config.key;
    this.configKeys.push(config.key);

    setTimeout(() => {
      if (config.key === MedReviewConfigKey.RELATED_TASK_TEMPLATES) {
        this.templatesAutocomplete.setValue(config.value?.length ? JSON.parse(config.value) : null);
        this.templatesAutocomplete.updateValueAndValidity();
      } else {
        this.value.nativeElement.value = config.value;
      }
    }, 100);
  }

  deleteConfig(event: Event, idx: number): void {
    event.stopPropagation();

    this.configKeys.push(this.configs[idx].key);
    this.configs.splice(idx, 1);
  }

  formatConfig(config: MedReviewConfig): string {
    return config.value
      ? config.key === MedReviewConfigKey.RELATED_TASK_TEMPLATES
        ? JSON.parse(config.value)
            .map((v) => v.name)
            .join(', ')
        : config.value
      : '';
  }

  closeDialog(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close();
  }

  submit(event: Event): void {
    event.stopPropagation();

    this.medReviewService
      .updateMedReviewConfigs(this.configs)
      .pipe(take(1))
      .subscribe((res) => {
        if (!res?.ok) return;

        this.dialogRef.close(true);
      });
  }
}
